// extracted by mini-css-extract-plugin
export default {"container":"GF-z","contactUsLink":"HF-z"};